import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface StatProps {
  label: string;
  value: ReactNode;
  delta?: { direction: "up" | "down"; label: string };
  sparkline?: ReactNode;
  className?: string;
}

/** KPI tile — DESIGN.md §9: caption label, h4 value (tnum), delta chip, sparkline right. */
export function Stat({ label, value, delta, sparkline, className }: StatProps) {
  return (
    <div className={cn("rounded-md border border-border bg-surface-2 p-4", className)}>
      <p className="text-caption text-text-muted uppercase">{label}</p>
      <div className="mt-2 flex items-end justify-between gap-2">
        <div>
          <div className="tnum text-h4 text-text-primary">{value}</div>
          {delta && (
            <p className={cn("tnum mt-1 text-small font-medium", delta.direction === "up" ? "text-accent" : "text-danger")}>{delta.label}</p>
          )}
        </div>
        {sparkline && <div className="h-6 w-16 shrink-0">{sparkline}</div>}
      </div>
    </div>
  );
}
